import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from "prop-types"

import MoneyItemSummary from '../userPaygoInfoProfile/profile-user-money-summary.jsx';
import PaymentList from '../userPaygoInfoProfile/paymentList.jsx';
import ChangeSuscription from '../userPaygoInfoProfileDynamic/profile-user-change-suscription.jsx';
import CommercialInCharge from '../userPaygoInfoProfileDynamic/profile-user-commercial-incharge.jsx';
import SpentList from '../userPaygoInfoProfileDynamic/profile-user-spent-list.jsx';
import { Grid } from '@material-ui/core';

class Payments extends Component {
    static propTypes = {
        profile_list: PropTypes.array.isRequired, // RESUME , LIST
        boxAssoId: PropTypes.string.isRequired
    };
    render (){
        const { profile_list, userInfo, boxAssoId } = this.props
        return (
            <Grid container spacing={2} >
                {profile_list.includes("RESUME") &&
                    <Grid item xs={12}>
                        <MoneyItemSummary boxAssoId={ boxAssoId }/>
                    </Grid>
                }   
                {profile_list.includes("LIST") &&
                    <Grid item xs={12}>
                        <PaymentList userInfo={userInfo}  boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("SPENT_LIST") &&
                    <Grid item xs={12}>
                        <SpentList boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("COMMERCIAL") &&
                    <Grid item xs={12}>
                        <CommercialInCharge boxId={userInfo.idBox}  userId={ userInfo.userID } boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("CHANGE_SUB") &&
                    <Grid item xs={12}>
                        <ChangeSuscription boxId={userInfo.idBox} userId={ userInfo.userID } boxAssoId={ boxAssoId }/>
                    </Grid>
                }
            </Grid>
        )
    }
}

export default Payments;
